(function(){
var root=document.getElementById('fzqf'),body=document.getElementById('fzqf-body');
if(!root||!body||window.__fzglide)return;window.__fzglide=1;
var top=root.querySelector('.top'),dir='up',last='',slog=null;
function dock(){
  top=root.querySelector('.top');if(!top)return;
  slog=top.querySelector('.fzsl');
  if(!slog&&window.FZQ_SLOGAN){slog=document.createElement('img');slog.className='fzsl';slog.alt='Breathe with elegance';slog.src=window.FZQ_SLOGAN;top.appendChild(slog)}
}
root.addEventListener('click',function(e){
  var t=e.target.closest('button,a');if(!t)return;
  if(t.hasAttribute('data-back'))dir='down';
  else if(t.hasAttribute('data-next')||t.hasAttribute('data-start')||t.hasAttribute('data-skip')||t.hasAttribute('data-v'))dir='up';
  if(t.hasAttribute('data-v')&&!/up to/i.test((body.querySelector('.hint')||{}).textContent||'')){
    setTimeout(function(){body.classList.add('fz-out')},110);
    setTimeout(function(){body.classList.remove('fz-out')},800);
  }
},true);
new MutationObserver(function(){
  dock();
  var h=body.querySelector('h2'),key=h?h.textContent:'';
  if(slog){if(root.classList.contains('wl'))slog.classList.remove('on');else slog.classList.add('on')}
  if(!key){last='';return}
  if(key===last)return;
  last=key;
  body.classList.remove('fz-out','fz-up','fz-down');
  void body.offsetWidth;
  body.classList.add(dir==='down'?'fz-down':'fz-up');
}).observe(body,{childList:true});
dock();
})();
